import { render, staticRenderFns } from "./GlobalGame.vue?vue&type=template&id=696699bc&scoped=true"
import script from "./GlobalGame.vue?vue&type=script&lang=js"
export * from "./GlobalGame.vue?vue&type=script&lang=js"
import style0 from "./GlobalGame.vue?vue&type=style&index=0&id=696699bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696699bc",
  null
  
)

export default component.exports